import React from 'react';
import { navigate } from 'gatsby';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/Layout';
import SEO from '../components/seo';
import { isBrowser } from '../utils/';
import { LoginForm } from '../components/login/login_form';
import promotion from '../../promotion_config';

import '../components/login/style.scss';
import Error from '../components/login/error';

export const Login = ({ user, notification, actions }) => {
    if (isBrowser() && user.loggedIn) {
        navigate('/enter');
    }

    return (
        <Layout user={user} notification={notification} actions={actions}>
            <SEO title="Log In" />
            <div className="login">
                <h1 className="title-section text-center">Log In</h1>
                <LoginInner user={user} actions={actions} />
            </div>
        </Layout>
    );
};

Login.propTypes = {
    user: PropTypes.any,
    notification: PropTypes.any,
    actions: PropTypes.any,
};

export const LoginInner = ({ user, actions }) => {
    return (
        <div className="page-content login-page">
            <div className="row">
                <p className="info-message">
                    Sign in to the Idaho Lottery VIP Club to play the Holiday
                    Bonus Snowball Fight game and reveal your entries for the
                    2nd chance drawing.
                </p>
            </div>

            <Error user={user} actions={actions} />
            <LoginForm user={user} actions={actions} />

            <p className="mt-4 font-weight-bold">
                NOT a member?&nbsp;
                <a
                    className="text-center font-weight-bold"
                    href={promotion.registerLink}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Register now.
                </a>
            </p>
        </div>
    );
};

LoginInner.propTypes = {
    user: PropTypes.any,
    notification: PropTypes.any,
    actions: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
